// src/theme/tokens/marketing.js
// Faz 1 · Pazarlama (landing) sayfasi semantic tokens.
// 19 token + MARKETING_WORD_TOKENS array kaldirildi (sifir kullanim teyit edildi).
// Faz 4 migrasyonu hicbir zaman tamamlanmadi · LandingPage hala hardcoded
// degerler kullaniyor. Yeni kullanim ihtiyaci dogarsa git history'den geri getirilebilir.

const marketingTokens = {};

// LandingPage.jsx WORDS dizisinin token-tabanli versiyonu (kaldirildi).
const MARKETING_WORD_TOKENS = [];

export default marketingTokens;
export { MARKETING_WORD_TOKENS };
